import { AUTHENTICATED_USER_SERVICE } from '@app/shared/auth/authenticated-user-service/authenticated-user-service.token';
import { AuthenticatedUserService } from '@app/shared/auth/keycloak/authenticated-user-service';
import { KeycloakTokenRefresher } from '@app/shared/auth/keycloak/keycloak-token-refresher.service';
import { LogoutService } from '@app/shared/auth/keycloak/logout-service';
import { OpenUserManagementService } from '@app/shared/auth/keycloak/open-user-management.service';
import { LOGOUT } from '@app/shared/auth/logout/logout.token';
import { OPEN_USER_MANAGEMENT } from '@app/shared/auth/user-management/open-user-management.token';
import { provideKeycloak } from 'keycloak-angular';
import { KeycloakRuntimeConfig } from '../runtime-config';

/**
 * L'annuaire est celui que désigne `/config.json`, lu avant l'appel : rien ici ne dépend de la
 * configuration de build.
 *
 * see https://www.keycloak.org/securing-apps/javascript-adapter
 */
export function vanexKeycloakProvider(keycloak: KeycloakRuntimeConfig) {
  return [
    provideKeycloak({
      config: { url: keycloak.url, realm: keycloak.realm, clientId: keycloak.clientId },
      initOptions: {
        onLoad: 'login-required',
      },
    }),
    // Eagerly instantiate the token refresher service so it starts refreshing tokens
    {
      provide: KeycloakTokenRefresher,
      useClass: KeycloakTokenRefresher,
    },
    { provide: LOGOUT, useClass: LogoutService },
    {
      provide: OPEN_USER_MANAGEMENT,
      useValue: new OpenUserManagementService(userManagementUrl(keycloak)),
    },
    { provide: AUTHENTICATED_USER_SERVICE, useClass: AuthenticatedUserService },
  ];
}

/** La liste des utilisateurs du realm, dans la console d'administration de l'annuaire. */
export function userManagementUrl({ url, realm }: KeycloakRuntimeConfig): string {
  return `${url}/admin/${realm}/console/#/${realm}/users`;
}
